import { footerLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-article-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                黑料平台
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              一个把「推荐、排行、哪个好、大全、合集」整理到一页的浏览指南站，
              帮你在众多平台入口里快速找到适合自己的那一个。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-900 text-background-200 transition-colors hover:bg-primary-600 hover:text-background-50"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-medium text-background-50">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-background-300 transition-colors hover:text-primary-300"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料平台 · 本页为静态展示范例，所有入口与按钮均不跳转外部站点。</p>
          <p className="whitespace-nowrap">内容仅供参考 · 请理性浏览</p>
        </div>
      </div>
    </footer>
  );
}